import React, { Component } from 'react';
import Loader from '../Loader';
import Table from '../Table';
import InfiniteScroll from "react-infinite-scroll-component";
import moment from 'moment';
import { variables } from '../../Tenants';
class CustomerFeedbackReportTable extends Component {

  state = {
    hasMoreRecords: true,
  }

  render() {
    const { reports} = this.props;
    return (
      <>       

        {reports && reports.length > 0 ? (
          <>
             {this.props.formLoader ?
               <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                <Loader loading={true} center={true}/>
                </div>
                : null}
            <div
              id="scrollableDiv"
              style={{
                height: 500,
                overflow: "auto",
                display: "flex",
                flexDirection: "column"
              }}
            >
                         
              <InfiniteScroll
                dataLength={reports.length}
                style={{ display: "flex", flexDirection: "column" }}
                inverse={false}
                scrollableTarget="scrollableDiv"
              >
                <Table
                  columns={[
                    {
                      label: `${variables.serviceRequest} Id`,
                      accessor: 'ticketNumber'
                    },
                    {
                        label: 'User/Account',
                        accessor: 'userName'
                    },
                    {
                        label: 'Email',
                        accessor: 'email'
                    },
                    {
                        label: 'Rating',
                        accessor: 'rating',
                    },
                    {
                        label: 'Feedback',
                        accessor: 'feedback'
                    },
                    {
                      label: 'Date',
                      cell: data => {
                        return (
                          moment(data.createdOn).format('MM/DD/YYYY')
                        )
                      }
                    },
                  ]}
                  data={reports}
                />
              </InfiniteScroll>
            </div>
          </>
        ) : (
            null
           
          )}
      </>
    );
  }
}


export default CustomerFeedbackReportTable;
